module.exports = __webpack_public_path__ + "static/media/10.022f9ebb.gif";